//@flow
import callCancel from '$api/cancel'

import {callWithFlags} from '$util'

export default function* authorize(bodyAsQs: string): Generator<> {
  return yield callWithFlags('cancel', callCancel, bodyAsQs)
}



// WEBPACK FOOTER //
// ./src/login/sagas/cancel.js